const config = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://indicadores.tangara.gov.co',
  // baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
  apiEndpoints: {
    obtenerIndicadores: '/api/indicadores',
    obtenerIndicadoresDetalle: '/api/indicadores/detalle/',
  },
};

export default config;
